import type { FC } from "react";
import { cn } from "utils";
import { ONBOARDING_WIZARD_ASSETS } from "../onboardingWizardAssets";
import { OnboardingBubbleTail } from "./OnboardingBubbleTail";
import { OnboardingEdAvatar } from "./OnboardingEdAvatar";

export { EdMarkLarge } from "./LoaderEdHero";

interface EdHeroBubbleProps {
  message?: string;
  greeting?: string;
  headline?: string;
  variant?: "dark" | "light";
  /** Figma Name step: avatar stacked above copy */
  layout?: "row" | "stacked";
  className?: string;
}

export const EdHeroBubble: FC<EdHeroBubbleProps> = ({
  message,
  greeting,
  headline,
  variant = "dark",
  layout = "row",
  className,
}) => (
  <div
    className={cn(
      layout === "stacked"
        ? "flex flex-col items-center gap-3"
        : "flex gap-2.5",
      className,
    )}
    data-testid="ed-hero-bubble"
  >
    <OnboardingEdAvatar />

    {message ? (
      <div
        className={cn(
          "relative flex-1 rounded-lg px-4 py-3.5",
          variant === "dark"
            ? "bg-content_secondary"
            : "bg-background_brand_overlay10",
        )}
        data-testid="ed-hero-message"
      >
        <OnboardingBubbleTail variant={variant} />
        <p
          className={cn(
            "body_medium_l",
            variant === "dark"
              ? "text-content_inverse_primary"
              : "text-content_primary",
          )}
          data-testid="ed-hero-message-text"
        >
          {message}
        </p>
      </div>
    ) : null}

    {!message && (greeting || headline) ? (
      <div
        className="flex w-full flex-col gap-0.5 text-center"
        data-testid="ed-hero-copy"
      >
        {greeting ? (
          <p
            className="body_l text-content_inverse_secondary"
            data-testid="ed-hero-greeting"
          >
            {greeting}
          </p>
        ) : null}
        {headline ? (
          <h2
            className="headline_regular_m text-content_inverse_primary"
            data-testid="ed-hero-headline"
          >
            {headline}
          </h2>
        ) : null}
      </div>
    ) : null}
  </div>
);

/** Placeholder when design exports land under ONBOARDING_WIZARD_ASSETS */
export const WIZARD_ASSET_FALLBACK = ONBOARDING_WIZARD_ASSETS;
